import {
  Box,
  Button,
  ButtonBase,
  Card,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { RootState } from "config/store";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { listItemCategory } from "shared/network/category.api";
import CategorySelectDialog from "./CategorySelectDialog";
import SellingFormCategoryItem from "./SellingFormCategoryItem";

const SellingFormCategoryList = ({
  selectedCategory,
  setSelectedCategory,
}: {
  selectedCategory: any;
  setSelectedCategory: any;
}) => {
  const { t } = useTranslation();
  const { selectedRelTenant } = useSelector((state: RootState) => state.authentication);
  const tenant = selectedRelTenant?.tenant;
  const [currentPage, setCurrentPage] = useState(0);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Kis képernyő ellenőrzése

  const categoriesQuery = useQuery(["categoriesQuery", tenant.id], async () => {
    const { data } = await listItemCategory(tenant.id);
    return data.items?.sort((a, b) => a?.name?.localeCompare(b?.name));
  });
  const categories = categoriesQuery.data || [];
  const isFetching = categoriesQuery.isLoading;

  const itemsPerPage = 8;
  const totalPages = Math.ceil(categories.length / itemsPerPage);

  const paginatedCategories = categories.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage,
  );

  return (
    <Box position="relative" pb={2}>
      <Typography variant="h6" style={{ fontSize: 16, padding: 8 }}>
        {t("Kategóriák")}
      </Typography>

      {isSmallScreen ? (
        <Box style={{ padding: "0 16px" }}>
          <CategorySelectDialog
            categories={categories}
            isFetching={isFetching}
            itemsPerPage={itemsPerPage}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
          />
        </Box>
      ) : (
        <>
          {paginatedCategories?.length !== 0 && (
            <ButtonBase
              disabled={currentPage === 0}
              onClick={() => {
                if (currentPage > 0) {
                  setCurrentPage(currentPage - 1);
                }
              }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1,
              }}
            >
              <ArrowBack
                style={{ fontSize: "24px", color: currentPage === 0 ? "gray" : "black" }}
              />
            </ButtonBase>
          )}
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="flex-start"
            alignItems="stretch"
            gridGap={16}
            mt={2}
            style={{ margin: "0 50px" }}
          >
            <Grid container spacing={2}>
              {isFetching ? (
                Array.from({ length: itemsPerPage }).map((_, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Skeleton
                      variant="rect"
                      height={80}
                      style={{
                        borderRadius: "4px",
                      }}
                    />
                  </Grid>
                ))
              ) : paginatedCategories?.length === 0 ? (
                <Grid item xs={12}>
                  <Typography
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                      color: "gray",
                    }}
                  >
                    {t("Nincsenek kategóriák.")}
                  </Typography>
                </Grid>
              ) : (
                paginatedCategories.map(category => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={category.id}>
                    <SellingFormCategoryItem
                      category={category}
                      selectedCategory={selectedCategory}
                      setSelectedCategory={setSelectedCategory}
                    />
                  </Grid>
                ))
              )}
            </Grid>
          </Box>
          {paginatedCategories?.length !== 0 && (
            <ButtonBase
              disabled={currentPage === totalPages - 1}
              onClick={() => {
                if (currentPage < totalPages - 1) {
                  setCurrentPage(currentPage + 1);
                }
              }}
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                height: "100%",
                width: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1,
              }}
            >
              <ArrowForward
                style={{
                  fontSize: "24px",
                  color: currentPage === totalPages - 1 ? "gray" : "black",
                }}
              />
            </ButtonBase>
          )}
        </>
      )}
    </Box>
  );
};

export default SellingFormCategoryList;
